import { ADMIN, COMMON, kevinAuthAPI, ifyouApi } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';
import { tableLimit } from 'utils/constant';
/// 다국어 설정

//시스템(일반) 다국어
// TODO: 카테고리 파라미터 추가
export const localizingApi = {
  read: ({
    page = 1,
    limit = tableLimit,
  }: { page?: number; limit?: number } = {}) =>
    kevinAuthAPI
      .get(`${COMMON}/localize`, {
        params: { page, limit },
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  update: (data) =>
    kevinAuthAPI
      .post(`${COMMON}/localize`, {
        rows: data,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};

//설문조사 다국어
export const surveyLocalizingList = async () => {
  try {
    const res = await ifyouApi.get(`${ADMIN}/survey-localize-list`);
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const surveyLocalizingUpdate = async (data) => {
  try {
    const res = await ifyouApi.post(`${ADMIN}/survey-localize-update`, {
      rows: data,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
